import { getHttpEndpoint } from "@orbs-network/ton-access";
import { TonClient } from "@ton/ton";

let endpoint: string ;

if(process.env.VITE_RPC_ENVIRONMENT === 'testnet') {
    endpoint =  await getHttpEndpoint({
        network: 'testnet',
    });
} else {
    endpoint = await getHttpEndpoint();
}

export const client = new TonClient({ endpoint });